import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
      { path: '/', component: require(page+'home.vue').default },
      { path: '/nosotros', component: require(page+'about-us/index.vue').default, meta:{title:"Nosotros"} },
      { path: '/preguntas-frecuentes', component: require(page+'faq/index.vue').default, meta:{title:"Preguntas frecuentes"} },
      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"} },
      { path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{title:"Aviso de Privacidad"} },
      { path: '/terminos-y-condiciones', component: require(page+'text-pages/terminos.vue').default, meta:{title:"Términos y condiciones"} },

      { path: '/niveles', component: require(page+'levels/index.vue').default, meta:{title:"Entrenamientos"} },
	  { path: '/niveles/:id', component: require(page+'levels/detail.vue').default, meta:{title:"Entrenamientos"} },
	  { path: '/entrenamientos/:nivels_id', component: require(page+'courses/results.vue').default, meta:{title:"Entrenamientos"} },
	  { path: '/entrenamiento/:id', component: require(page+'courses/detail.vue').default, meta:{title:"Entrenamientos"} },
      { path: '/busqueda', component: require(page+'courses/search.vue').default, meta:{title:"Entrenamientos"} },
      

      { path: '/blog', component: require(page+'blog/results.vue').default, meta:{title:"Distinciones"} },
      { path: '/blog/:id', component: require(page+'blog/detail.vue').default, meta:{title:"Distinciones"} },

      { path: '/cart/:step?', component: require(page+'carrito/index.vue').default, meta:{title:"Mi carrito de compras"}},
	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Impacto Cuántico", filter: (title)=>{ return title+" - Impacto Cuántico"; } }
);

// export {routes};
export default MyRouter;
